import {config as yesNoOverdueColumn} from '../../common/YesNoOverdueColumn';

export const prop = 'hasCRAPICSO';
export const id = 'picOnCraColumn';

export const config = (labels) =>
	yesNoOverdueColumn({
		fullId: id,
		label: labels.picSignoffOnCra,
		prop,
		width: 'minmax(var(--px-170), 2fr)',
		isOverdue: (item) => item[prop] === false && item.isPartCRASODlyd === true
	});
